import React from "react";
import { Button } from "./Button";
import "../App.css";
import "./HeroSection.css";

function buttonLink() {
  window.open("https://chirocat.app/innovative-health-solutions/bookings", "_blank");
  return 0;
}

function HeroSection() {
  return (
    <div className="hero-container">
      <video className="backGroundVideo" autoPlay loop muted>
        <source src="/videos/motionEffectBackground.MP4" type="video/mp4" />
      </video>
      <h1>A Journey to a Better You, Begins With You</h1>
      <p>No one's stopping you</p>
      <div className="hero-btns"></div>
    </div>
  );
}

export default HeroSection;
